import { Routes, Route} from 'react-router'
import Home from "./pages/Home";
import Blog from "./pages/Blog";
import Contact from "./pages/Contact";
import Projects from "./pages/Projects";
import {BrowserRouter} from 'react-router-dom'
import 'animate.css';
import 'aos/dist/aos.css'

function App() {


  return (
      
    <div className="App bg-gradient-to-b from-v via-dbb to-v  ">
          <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/projects" element={<Projects/>}/>
        <Route path="/blog" element={<Blog/>}/>
        <Route path="/contact" element={<Contact/>}/>
      </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
